import { AceUIIcon, BadgeState, IconFontStyle } from '@ace/shared';
import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'ws-ace-badge',
    templateUrl: './badge.component.html',
    standalone: false,
    styleUrls: ['./badge.component.scss']
})
export class AceBadgeComponent {
    @Input() content: string;
    @Input() icon: AceUIIcon | string;
    @Input() iconFont: IconFontStyle | IconFontStyle[] | string;
    @Input() iconSlot: string = 'icon';

    @HostBinding('attr.size')
    @Input() size: 'default' | 'small';

    @HostBinding('attr.badge-state')
    @Input() badgeState: BadgeState | string;
}
